import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/697b3017921dc900141be80b/cis_solutions/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/697b3017921dc900141be80b/cis_solutions/src/app/portfolio/components/PortfolioInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/697b3017921dc900141be80b/cis_solutions/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/697b3017921dc900141be80b/cis_solutions/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/697b3017921dc900141be80b/cis_solutions/src/components/ui/AppImage.tsx");
